import { render, staticRenderFns } from "./item-products.vue?vue&type=template&id=1ffd95c4&"
import script from "./item-products.vue?vue&type=script&lang=js&"
export * from "./item-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports